module.exports = __webpack_public_path__ + "img/file.e3c2c80f.svg";